export default __webpack_public_path__ + "static/media/partner6.f10a8176.webp";